let ctx: AudioContext | null = null;

export function audioCtx(): AudioContext {
  if (!ctx) {
    ctx = new AudioContext({ latencyHint: 'interactive' });
  }
  return ctx;
}

export async function resumeAudio(): Promise<void> {
  const c = audioCtx();
  if (c.state !== 'running') await c.resume();
}
